import React from "react";
import { Col, Row } from "react-bootstrap";
import profileicon from "@frameworks/shared-library/assets/images/salesjourney/profile/profile-icon.svg";
import { addDashIfNullOrUndefined } from "@domains/utils/numberMethods";
var Clientprofilecard = function (props) {
    var _a, _b, _c, _d;
    return (React.createElement("div", { className: "clientprofilecard-block ".concat(props.parentclassName ? props.parentclassName : "") },
        React.createElement(Row, { className: "m-0" },
            React.createElement(Col, { lg: 9, md: 9, className: "px-0 client-details-row" },
                React.createElement("div", { className: "designation" }, props.designation),
                React.createElement("div", null, addDashIfNullOrUndefined((_a = props === null || props === void 0 ? void 0 : props.data) === null || _a === void 0 ? void 0 : _a.name)),
                React.createElement("div", null,
                    React.createElement("i", { className: "edel-icon-call1" }),
                    addDashIfNullOrUndefined((_b = props === null || props === void 0 ? void 0 : props.data) === null || _b === void 0 ? void 0 : _b.emailId)),
                ((_c = props === null || props === void 0 ? void 0 : props.data) === null || _c === void 0 ? void 0 : _c.contactNo) && (React.createElement("div", null,
                    React.createElement("i", { className: "edel-icon-call1" }),
                    addDashIfNullOrUndefined((_d = props === null || props === void 0 ? void 0 : props.data) === null || _d === void 0 ? void 0 : _d.contactNo))),
                props.sincetime && (React.createElement("div", null,
                    React.createElement("i", { className: "edel-icon-timer" }),
                    addDashIfNullOrUndefined(props.sincetime)))),
            React.createElement(Col, { lg: 3, md: 3, className: "px-0" },
                React.createElement("img", { alt: "", className: "profile-img hand_cursor", src: profileicon })))));
};
export default Clientprofilecard;
